(() => {
  if (window.DuduGiftCatalog) return;
  const cache = new Map();
  const names = {category:'dg_category',type:'dg_type',recipients:'dg_recipient',interests:'dg_interest',occasions:'dg_occasion',colors:'dg_color',personalized:'dg_personalized',stock:'dg_stock'};
  const legacy = {category:'filter.p.m.custom.gift_category',type:'filter.p.product_type',recipients:'filter.p.m.custom.gift_recipients',interests:'filter.p.m.custom.gift_interests',occasions:'filter.p.m.custom.gift_occasions',colors:'filter.p.m.custom.gift_colors',personalized:'filter.p.m.custom.gift_personalized',stock:'filter.v.availability'};
  const colorRules = [['Rose gold',/rose[ -]?gold/i],['Gold',/gold/i],['Silver',/silver|silvery|sliver|steel color|titanium/i],['Black',/black|onyx|ebony/i],['White',/white|ivory|milky/i],['Gray',/gray|grey|graphite/i],['Turquoise',/turquoise|teal/i],['Green',/green|olive|matcha/i],['Blue',/blue|navy|sapphire/i],['Purple',/purple|violet|lavender|grape/i],['Pink',/pink|rose red|small powder|bean paste/i],['Red',/\bred\b|burgund|burgend|vermilion|wine red/i],['Orange',/orange/i],['Yellow',/yellow/i],['Brown',/brown|coffee|tan\b|wood color|khaki/i],['Beige',/beige|apricot|nude|skin|cream/i],['Clear',/transparent|clear/i]];
  const decode = value => {
    const element = document.createElement('textarea');
    element.innerHTML = String(value ?? '');
    return element.value;
  };
  const values = value => (Array.isArray(value) ? value : value ? [value] : []).map(decode);
  function normalize(product) {
    for (const key of ['recipients','interests','occasions','colors']) product[key] = values(product[key]);
    product.category = decode(product.category);
    product.type = decode(product.type);
    product.title = decode(product.title);
    if (product.image) product.image.alt = decode(product.image.alt);
    product.personalized = product.personalized === true || product.personalized === 'true';
    product.variants = (product.variants || []).map(variant => ({...variant,colors:colorRules.filter(([label,pattern])=>pattern.test(variant.color || '') && !(label==='Gold' && /rose[ -]?gold/i.test(variant.color || ''))).map(([label])=>label)}));
    return product;
  }
  function baseUrl(value) {
    const url = new URL(value, location.origin);
    for (const key of [...url.searchParams.keys()]) if (key.startsWith('dg_') || key.startsWith('filter.') || key==='page' || key==='section_id' || key==='view') url.searchParams.delete(key);
    if (url.pathname.replace(/\/$/,'').endsWith('/search')) url.searchParams.set('type','product');
    return url;
  }
  async function load(value) {
    const base = baseUrl(value), key = base.href;
    if (cache.has(key)) return cache.get(key);
    const promise = (async () => {
      const products = [], seen = new Set(), pages = new Set();
      let url = new URL(base);
      while (url) {
        url.searchParams.set('view','dg-catalog-data');
        if (url.origin !== location.origin || pages.has(url.href)) throw new Error('Invalid catalog page');
        pages.add(url.href);
        const response = await fetch(url.href,{headers:{Accept:'text/html'}});
        if (!response.ok) throw new Error('Catalog unavailable');
        const fragment = new DOMParser().parseFromString(await response.text(),'text/html');
        const block = fragment.querySelector('[data-dg-catalog-data]');
        if (!block) throw new Error('Catalog unavailable');
        const data = JSON.parse(block.textContent);
        if (!Array.isArray(data.products)) throw new Error('Invalid catalog');
        for (const product of data.products) if (product.id && !seen.has(product.id)) {seen.add(product.id);products.push(normalize(product));}
        url = data.next ? new URL(data.next,base) : null;
      }
      return products;
    })();
    cache.set(key,promise);
    try {return await promise;} catch (error) {cache.delete(key);throw error;}
  }
  function read(url) {
    const criteria = {};
    for (const [key,name] of Object.entries(names)) criteria[key] = url.searchParams.getAll(name).concat(url.searchParams.getAll(legacy[key])).filter(Boolean).map(decode);
    criteria.min = url.searchParams.get('filter.v.price.gte') || '';
    criteria.max = url.searchParams.get('filter.v.price.lte') || '';
    criteria.page = Math.max(1,Number(url.searchParams.get('page')) || 1);
    return criteria;
  }
  function variantMatches(product,variant,criteria,exclude) {
    if (exclude!=='price' && criteria.min!=='' && variant.price<Math.round(Number(criteria.min)*100)) return false;
    if (exclude!=='price' && criteria.max!=='' && variant.price>Math.round(Number(criteria.max)*100)) return false;
    if (exclude!=='stock' && criteria.stock?.includes('1') && !variant.available) return false;
    if (exclude!=='stock' && criteria.stock?.includes('0') && !criteria.stock?.includes('1') && variant.available) return false;
    if (exclude!=='colors' && criteria.colors?.length) {
      const colors = variant.colors.length ? variant.colors : product.colors;
      if (!criteria.colors.some(value=>colors.includes(value))) return false;
    }
    return true;
  }
  function matches(product,criteria,exclude) {
    for (const key of ['category','type','recipients','interests','occasions']) {
      if (key===exclude || !criteria[key]?.length) continue;
      const options = Array.isArray(product[key]) ? product[key] : [product[key]];
      if (!criteria[key].some(value=>options.includes(value))) return false;
    }
    if (exclude!=='personalized' && criteria.personalized?.includes('true') && !product.personalized) return false;
    if (!product.variants.length) return variantMatches(product,{price:product.price,available:product.available,colors:product.colors},criteria,exclude);
    return product.variants.some(variant=>variantMatches(product,variant,criteria,exclude));
  }
  function write(value,criteria) {
    const url = baseUrl(value);
    for (const [key,name] of Object.entries(names)) for (const option of criteria[key] || []) if (option) url.searchParams.append(name,option);
    if (criteria.min!=='' && criteria.min!=null) url.searchParams.set('filter.v.price.gte',criteria.min);
    if (criteria.max!=='' && criteria.max!=null) url.searchParams.set('filter.v.price.lte',criteria.max);
    if (criteria.page>1) url.searchParams.set('page',String(criteria.page));
    return url;
  }
  window.DuduGiftCatalog = {load,read,write,matches,variantMatches,values,decode,names,baseUrl};
})();
